module.exports = __webpack_public_path__ + "img/widget-design_date.9f28c46c.jpg";